import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

/*
 * Menu interface
 */
export interface Menu {
  state: any;
  name?: string;
  type?: string;
  icon?: string;
  fragment?: string;
  children?: ChildrenItems[];
  id?: string;
}

/*
 * Children menu interface
 */
export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

@Injectable()
export class MenuItems {
  HEADERMENUITEMS: Menu[] = [
    {
      state: "home",
      name: "Inicio",
      type: "link",
    },
    {
      state: "history-presence",
      name: "Institución",
      type: "link",
    },
    {
      // Dropdown poblado dinámicamente con los niveles (GET /public/levels);
      // cada hijo enlaza a /level-profile/:id
      state: "level-profile",
      name: "Niveles",
      type: "sub",
      children: [],
    },
    {
      state: "news",
      name: "Novedades",
      type: "link",
    },
    {
      state: "inscriptions",
      name: "Inscripciones",
      type: "link",
    },
    {
      state: "contact",
      name: "Contacto",
      type: "link",
    },
  ];

  AUTHITEMS = [
    {
      state: ["logged", "home"],
      name: "Home",
      type: "nested",
    },
    {
      state: "news",
      name: "Institucional",
      type: "link",
    },
    {
      state: ["logged", "communication"],
      name: "Comunicaciones",
      type: "nested",
    },
    {
      state: ["logged", "students"],
      name: "Estudiantes",
      type: "nested",
    },
    {
      state: ["logged", "workshop"],
      name: "Talleres",
      type: "nested",
    },

    // {
    //   state: ["courses", "aula"],
    //   name: "Rooms",
    //   type: "nested"
    // },
    /*{
      state: ["logged", "products"],
      name: this.translate.instant("Products"),
      type: "nested",
      id: 'products'
    },*/
    /*{
      state: ["logged", "messages"],
      name: this.translate.instant("Messages"),
      type: "nested",
      id: 'messages'
    },*/
    {
      state: ["logged", "faqs"],
      name: "Support",
      type: "nested",
    },
    {
      state: ["logged", "profile"],
      name: "Profile",
      type: "nested",
    },
  ];

  constructor(public translate: TranslateService) {}

  /*
   * Get all header menu
   */
  getMainMenu(): Menu[] {
    return this.HEADERMENUITEMS;
    //  return HEADERMENUITEMS;
  }

  getAuthMenu(): Menu[] {
    return this.AUTHITEMS;
  }
}
